export default list => {
  if(!list) {
    return 0;
  }

  return list.reduce((acc, item) => acc += item.total, 0);
}
